export const FETCH_TRENDING = 'FETCH_TRENDING_MOVIES'
export const FETCH_TRENDING_REQUEST = 'FETCH_TRENDING_REQUEST'
export const FETCH_TRENDING_SUCCESS = 'FETCH_TRENDING_SUCCESS'